import { Dimensions } from 'react-native';
import { MOBILE_WIDTH_CUTOFF } from '../utils/constants';

export const useIsMobileLayout = () => {
    return Dimensions.get('window').width < MOBILE_WIDTH_CUTOFF;
};
